import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  SimpleGrid,
  Button,
  Icon,
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
  Heading,
  Input,
  Stack,
  useToast,
  useColorModeValue,
} from "@chakra-ui/react";
import { FiPlus } from "react-icons/fi";

import Card from "components/card/Card.js";

export default function ChangeName() {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("authToken");
  const toast = useToast();

  useEffect(() => {}, []);

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid columns={{ base: 1, sm: 1, md: 2, lg: 2 }}>
        <Card align="center" p="20px">
          <Stack
            spacing={4}
            w={"full"}
            maxW={"md"}
            bg={useColorModeValue("white", "gray.700")}
            p={6}
            my={5}
          >
            <FormControl>
              <FormLabel>First Name</FormLabel>
              <Input type="text" value="" onChange="" borderRadius="20" />
            </FormControl>

            <FormControl>
              <FormLabel>Last Name</FormLabel>
              <Input type="text" value="" onChange="" borderRadius="20" />
            </FormControl>

            <Button
              bg={"blue.400"}
              color={"white"}
              w="full"
              borderRadius="20"
              _hover={{
                bg: "blue.500",
              }}
            >
              Submit
            </Button>
          </Stack>
        </Card>
      </SimpleGrid>
    </Box>
  );
}
